import {Component, Object3D, RetainEmitter} from '@wonderlandengine/api';
import {WLUtils} from '../utils/WLUtils.js';
import {CustomLogTag} from '../classes/Constants.js';

export class FXPrefabs extends Component {
    static TypeName = 'fx-prefabs';

    // Singleton
    private static _instance: FXPrefabs;
    static get instance(): FXPrefabs {
        return FXPrefabs._instance;
    }

    fxPrefabs!: Object3D;
    onPrefabsLoaded = new RetainEmitter<[Object3D]>();

    private _isLoaded = false;
    get isLoaded() {
        return this._isLoaded;
    }

    init(): void {
        FXPrefabs._instance = this;
    }

    async start() {
        const s = await this.engine.loadPrefab('FXPrefabs.bin');
        const r = this.engine.scene.instantiate(s);
        this.fxPrefabs = r.root;
        this.fxPrefabs.parent = this.object;

        WLUtils.setActive(this.fxPrefabs, false);
        this._isLoaded = true;
        setTimeout(() => this.onPrefabsLoaded.notify(this.fxPrefabs), 0);
    }
    /**
     * Spawns a effect with the given name
     * @param name Name of the effect to spawn
     * @param parent Optional parent object of the effect
     * @param startActive Optional boolean to set the active state of the effect; default is false
     * @returns The spawned effect object or null if spawn failed
     */
    spawn(name: string, parent: Object3D | null = null, startActive = false) {
        if (!this.fxPrefabs) {
            this.engine.log.warn(
                CustomLogTag.Game,
                `Spawning Effect Failed. Effects Prefabs not loaded`
            );
            return null;
        }

        const fx = this.fxPrefabs.findByName(name)[0];

        if (!fx) {
            this.engine.log.warn(
                CustomLogTag.Game,
                `Spawning Effect Failed. Effect with name ${name} not found`
            );
            return null;
        }

        const clonedEffect = WLUtils.clone(fx, parent);

        //this.engine.log.info(CustomLogTag.Game, `Spawned Effect ${name}`);
        if (startActive) {
            WLUtils.setActive(clonedEffect, true);
        }

        clonedEffect.resetPositionRotation();
        return clonedEffect;
    }
}
